import homeProgress0 from 'url:../../../assets/images/home-progress-0.webp';
import workoutResults1 from 'url:../../../assets/images/workout-results-1.webp';
import workoutResults2 from 'url:../../../assets/images/workout-results-2.webp';
import workoutResults3 from 'url:../../../assets/images/workout-results-3.webp';
import workoutResults4 from 'url:../../../assets/images/workout-results-4.webp';
import workoutResults5 from 'url:../../../assets/images/workout-results-5.webp';
import workoutResults6 from 'url:../../../assets/images/workout-results-6.webp';
import workoutResults7 from 'url:../../../assets/images/workout-results-7.webp';
import workoutResults8 from 'url:../../../assets/images/workout-results-8.webp';
import workoutResults9 from 'url:../../../assets/images/workout-results-9.webp';
import workoutResults10 from 'url:../../../assets/images/workout-results-10.webp';
import workoutResults11 from 'url:../../../assets/images/workout-results-11.webp';
import workoutResults12 from 'url:../../../assets/images/workout-results-12.webp';
import workoutResults13 from 'url:../../../assets/images/workout-results-13.webp';
import workoutResults14 from 'url:../../../assets/images/workout-results-14.webp';
import workoutResults15 from 'url:../../../assets/images/workout-results-15.webp';
import workoutResults16 from 'url:../../../assets/images/workout-results-16.webp';
import workoutResults17 from 'url:../../../assets/images/workout-results-17.webp';
import workoutResults18 from 'url:../../../assets/images/workout-results-18.webp';
import workoutResults19 from 'url:../../../assets/images/workout-results-19.webp';
import workoutResults20 from 'url:../../../assets/images/workout-results-20.webp';
import workoutResults21 from 'url:../../../assets/images/workout-results-21.webp';
import workoutResults22 from 'url:../../../assets/images/workout-results-22.webp';

export const workoutResultsImages = {
  homeProgress0,
  workoutResults1,
  workoutResults2,
  workoutResults3,
  workoutResults4,
  workoutResults5,
  workoutResults6,
  workoutResults7,
  workoutResults8,
  workoutResults9,
  workoutResults10,
  workoutResults11,
  workoutResults12,
  workoutResults13,
  workoutResults14,
  workoutResults15,
  workoutResults16,
  workoutResults17,
  workoutResults18,
  workoutResults19,
  workoutResults20,
  workoutResults21,
  workoutResults22,
} as const;

export const workoutResultsImageList = Object.values(workoutResultsImages);
